// Generated file : do not modify
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Dsn
export class DsnReminder {
  // Établissement
  public etablissementId: number;
  // Nom de l'établissement
  public nom: string;
  // SIRET
  public siret: string;
  // Période
  public periode: string;
  // Mois
  public mois: string;
  // Date limite
  public dateLimite: string;
  // Avant la date limite
  public avantDateLimite: boolean;

  constructor() {
    this.etablissementId = 0;
    this.nom = '';
    this.siret = '';
    this.periode = '';
    this.mois = '';
    this.dateLimite = '';
    this.avantDateLimite = false;
  }
}

export default class Dsn  {
  // ID client
  public clientId: number;
  // Code DSN déclaration
  public CODE_DSN_DECLARATION : number;

  constructor() {
    this.clientId = 0;
    this.CODE_DSN_DECLARATION  = 0;
  }

  public static fromJson (obj: Dsn): Dsn {
    const newDsn: Dsn = new Dsn();
    newDsn.clientId = obj.clientId;
    newDsn.CODE_DSN_DECLARATION  = obj.CODE_DSN_DECLARATION ;
    return newDsn;
  }

  public toJsonDsn (): string {
    const json = {
      clientId: this.clientId,
      CODE_DSN_DECLARATION : this.CODE_DSN_DECLARATION ,
    }
    return JSON.stringify(json);
  }

  public fromDsn (obj: Dsn): void {
    this.clientId = obj.clientId;
    this.CODE_DSN_DECLARATION  = obj.CODE_DSN_DECLARATION ;
  }

  public compareDsn (value: Dsn): boolean {
    return (this.toJsonDsn() == value.toJsonDsn());
  }

  public cloneDsn (): Dsn {
    return Dsn.fromJson(this);
  }

  public static envoi (dsn: Dsn): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/dsns/envoi', dsn, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static aer (dsn: Dsn): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/dsns/aer', dsn, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static reminders (): Promise<DsnReminder[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/dsns/reminders', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: DsnReminder[] = [];
              res.data.forEach(( a: DsnReminder ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(dsns: Dsn[]) {
  }
}
